// extracted by mini-css-extract-plugin
export var fullWidthStyle = "style-mod--full-width-style--c6fe8";
export var richTextWrapper = "style-mod--rich-text-wrapper--2930c";
export var sectionWrapper = "style-mod--section-wrapper--bf75e";
export var tableRow = "style-mod--table-row--94b3c";